import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgFlightOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.503 11.636 7.695 10.8s-1.111-.116-2.072-1.517c-.961-1.4-1.93-2.854-1.93-2.854s-.17-.35-.58-.289c-.407.06-.243.489-.243.489l.56 3.117s.02.77.699 1.226c.68.456 2.72 1.752 2.72 1.752s1.405.873 3.623 1.341c2.218.469 10.066 2.228 10.066 2.228s2.982.759 3.23.114c.248-.645-.981-1.592-1.675-1.935-.693-.343-7.104-1.983-7.104-1.983l-3.048-5.932s-.454-.705-.49-.08c-.036.626.087 6.265.087 6.265m-.442 2.716.051 2.42s.085.63 1.109-.29c1.024-.92 1.81-1.59 1.81-1.59"
      stroke="#919499"
    />
  </svg>
);
const Memo = memo(SvgFlightOut);
export default Memo;
